import { render, staticRenderFns } from "./AccommodationFields.vue?vue&type=template&id=45418dbe"
import script from "./AccommodationFields.vue?vue&type=script&lang=js"
export * from "./AccommodationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports